// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { createContext } from 'react'

export const pathCartDrawerContext = createContext()

export const pathCartStoreContext = createContext()
export const pathCartStoreActionsContext = createContext()
